/**
 * Persistência da última rota e organização para restaurar após F5.
 * Usado em App (PersistLastRoute) e em Index (redirecionamento).
 */

export const FLUITY_LAST_PATH_KEY = "fluity_last_path";

/** Prefixos de rotas do app (área logada) que devem ser persistidas. */
export const APP_PATH_PREFIXES = [
  "/chat",
  "/profile",
];

export function isAppPath(pathname: string): boolean {
  if (!pathname || pathname === "/") return false;
  return APP_PATH_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(prefix + "/")
  );
}

/** Retorna o último path salvo se for uma rota válida do app, ou null. */
export function getLastAppPath(): string | null {
  try {
    const lastPath = localStorage.getItem(FLUITY_LAST_PATH_KEY);
    if (!lastPath || !lastPath.startsWith("/")) return null;
    const pathname = lastPath.split("?")[0];
    if (isAppPath(pathname)) return lastPath;
  } catch {
    // ignorar
  }
  return null;
}
